/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface ManualFolderList {
  foldersHasTags?: SortedFoldersWithTags[];
  unassignedTags?: TreatmentTagForFolder[];
}

export interface SortedFoldersWithTags {
  /**
   * 폴더 ID
   * @example "60a12345b1234c56789abcd1"
   */
  _id: string;
  /**
   * 폴더 이름
   * @example "피부 관리"
   */
  name: string;
  /**
   * 폴더 정렬 순서 - 클수록 먼저 표시됨
   * @example 1
   */
  sortNum: number;
  /**
   * 폴더 활성화 여부
   * @example true
   */
  isActive: boolean;
  treatmentTags?: TreatmentTagForFolder[];
}

export interface TreatmentTagForFolder {
  /**
   * 치료 태그 ID
   * @example "60a12345b1234c56789abcd1"
   */
  _id: string;
  /**
   * 치료 태그 이름
   * @example "기미"
   */
  categoryName: string;
  /**
   * 치료 태그 정렬 순서 - 클수록 먼저 표시됨
   * @example 1
   */
  sortNum: number;
  /**
   * 치료 태그 활성화 여부
   * @example true
   */
  isActive: boolean;
  /**
   * 치료 태그 색상 팔레트 인덱스
   * @example 1
   */
  paletteIndex: number;
  /**
   * 사용자 정의 색상 사용 여부
   * @example false
   */
  isUsingCustomColor: boolean;
  /**
   * 치료 태그 색상
   * @example "#FFFFFF"
   */
  color: string;
  /**
   * AI 상담코치 필수 참조 매뉴얼 여부 (병원당 1개)
   * @example false
   */
  isAiMandatoryReference: boolean;
}

export interface ManualResponse {
  /**
   * 치료 태그 ID
   * @example "66ac5bae07a37e99d4ae628d"
   */
  tagId: string;
  /**
   * 치료 태그 이름
   * @example "피부 관리"
   */
  tagName: string;
  /**
   * 치료 태그 색상
   * @example "#FF0000"
   */
  tagColor: string;
  /**
   * 매뉴얼 내용
   * @example "피부 관리 기본 매뉴얼 내용입니다..."
   */
  manualContent?: string;
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  fileID?: string;
  /**
   * 파일 생성일
   * @format date-time
   * @example "2023-07-25T10:00:00.000Z"
   */
  fileCreatedAt?: string;
  /**
   * 파일 수정일
   * @format date-time
   * @example "2023-07-25T10:00:00.000Z"
   */
  fileUpdatedAt?: string;
  cautionImages?: {
    /**
     * 파일 이름
     * @example "skincare1.jpg"
     */
    fileName?: string;
    /**
     * 파일 크기
     * @example 1024
     */
    fileSize?: number;
    /**
     * 파일 URL
     * @example "https://example.com/images/skincare1.jpg"
     */
    url: string;
  }[];
  /**
   * 활성화 여부
   * @example true
   */
  isActive?: boolean;
  /**
   * AI 상담코치 필수 참조 매뉴얼 여부 (병원당 1개)
   * @example false
   */
  isAiMandatoryReference?: boolean;
  /**
   * 알림톡, 애프터닥 내 주의사항 발송 여부
   * @example false
   */
  usingCautionMessage?: boolean;
  /**
   * 알림톡, 애프터닥 내 주의사항 텍스트 콘텐츠. templateInfo 내 templateContent와 동일
   * @example "#{고객명}님 안녕하세요 🩷
   * 저희  #{병원명} 은 언제나 고객님의 건강을 위해 노력하고 있습니다.
   *
   * 불편하신 점 있으시거나, 관련 문의사항 있으실 경우 언제든지 병원으로 연락 주시면 친절히 안내 도와드리겠습니다."
   */
  cautionMessage?: string;
  /**
   * 알림톡 템플릿의 senderKey 클라이언트에서의 디버깅을 위해 추가
   * @example false
   */
  kakao_senderKey?: boolean;
  /**
   * 알림톡 템플릿의 senderKeyType 클라이언트에서의 디버깅을 위해 추가
   * @example false
   */
  kakao_senderKeyType?: boolean;
  /**
   * 알림톡 템플릿의 templateCode 클라이언트에서의 디버깅을 위해 추가
   * @example false
   */
  kakao_templateCode?: boolean;
  kakaoTemplateInfo?: KakaoTemplateInfo;
}

export interface KakaoTemplateInfo {
  /**
   * -
   * @example false
   */
  block?: boolean;
  /** 미사용 */
  buttons?: Record<string, any>[];
  /**
   * kakao에서 제공하는 카테고리 코드
   * @example 4001
   */
  categoryCode?: string;
  /** 검수 결과에 해당하는 코멘트 - 반려인 경우 존재 */
  comments?: {
    /**
     * 코맨트 내용
     * @example "안녕하세요. 카카오톡 알림톡 검수 담당자입니다.
     *
     * 알림톡은 수신자의 액션을 기반한 정보성 메시지에 한하여 발송 가능합니다.
     * 허나 해당 메시지는 수신자가 요청하지 않은 내용으로 광고성 및 공지성 메시지에 해당함에 따라 알림톡 발송 불가합니다.
     *
     * 더 자세한 알림톡 검수 가이드는 딜러사를 통해 확인 부탁드립니다.
     * 감사합니다."
     */
    content?: string;
    /**
     * 코맨트의 생성 일시를 표기하는 문자열
     * @example "2025-03-25 08:50:22"
     */
    createdAt?: string;
    /**
     * 코맨트 생성간 변경된 상태 코드
     * @example "REJ"
     */
    status?: string;
    /**
     * 해당 코멘트를 남긴 검수자 명
     * @example "검수자"
     */
    userName?: string;
    attachment?: Record<string, any>[];
  }[];
  /**
   * 해당 템플릿의 생성일시 문자열
   * @example "2025-03-25 08:50:22"
   */
  createdAt?: string;
  /**
   * 미사용
   * @example false
   */
  dormant?: boolean;
  /**
   * 해당 템플릿의 상태
   * @example "REG(등록), REQ(검수요청), REJ(반려), ..."
   */
  inspectionStatus?: "REG" | "REQ" | "REJ" | "STP" | "RDY" | "ACT" | "DMT" | "BLK" | "APR";
  /**
   * 해당 템플릿의 마지막 수정일시 문자열
   * @example "2025-03-25 08:50:22"
   */
  modifiedAt?: string;
  /**
   * 미사용
   * @example "-"
   */
  quickReplies?: string;
  /**
   * 미사용
   * @example "-"
   */
  securityFlag?: boolean;
  /**
   * 템플릿 등록에 사용된 senderKey
   * @example "3f789b2e70ec92bb0b671a3ba819805f0da60b63"
   */
  senderKey?: string;
  /**
   * 템플릿 등록에 사용된 senderKey의 Type 구분자. S or G
   * @example "G"
   */
  senderKeyType?: string;
  /**
   * 템플릿의 상태값. inspectionStatus와 함께 해당 템플릿이 요청될 수 있는 요청(검수요청, 삭제, 발송 등)상태를 구분짓기 위해 사용. 클라이언트에서는 미사용
   * @example "R"
   */
  status?: string;
  /**
   * 각 템플릿을 구분짓기 위한 Unique Identifier
   * @example "bizp_2025032115202325399988693"
   */
  templateCode?: string;
  /**
   * 해당 템플릿에서 대상에게 보내겔 콘텐츠 문자열
   * @example "#{고객명}님 안녕하세요 🩷
   * 저희  #{병원명} 은 언제나 고객님의 건강을 위해 노력하고 있습니다.
   *
   * 불편하신 점 있으시거나, 관련 문의사항 있으실 경우 언제든지 병원으로 연락 주시면 친절히 안내 도와드리겠습니다."
   */
  templateContent?: string;
  /**
   * 미사용
   * @example "NONE"
   */
  templateEmphasizeType?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateExtra?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateHeader?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateImageName?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateImageUrl?: string;
  /**
   * 템플릿의 메세지 타입 구분자
   * @example "BA"
   */
  templateMessageType?: string;
  /**
   * 해당 템플릿의 템플릿명
   * @example "안내 종결_9khgy"
   */
  templateName?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateSubtitle?: string;
  /**
   * 미사용
   * @example "-"
   */
  templateTitle?: string;
}

export interface TreatmentCategoryControllerGetManualFolderListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 폴더와 그 하위 치료 태그 목록 */
    foldersHasTags: {
      /** 폴더 ID */
      _id?: string;
      /** 폴더 이름 */
      name?: string;
      /** 폴더 정렬 순서 - 클수록 먼저 표시됨 */
      sortNum?: number;
      /** 폴더 활성화 여부 */
      isActive?: boolean;
      /** 폴더에 속한 치료 태그 목록 */
      treatmentTags: {
        /** 치료 태그 ID */
        _id?: string;
        /** 치료 태그 이름 */
        categoryName?: string;
        /** 치료 태그 정렬 순서 - 클수록 먼저 표시됨 */
        sortNum?: number;
        /** 치료 태그 활성화 여부 */
        isActive?: boolean;
        /** 치료 태그 색상 팔레트 인덱스 */
        paletteIndex?: number;
        /** 사용자 정의 색상 사용 여부 */
        isUsingCustomColor?: boolean;
        /** 치료 태그 색상 */
        color?: string;
        /** AI 상담코치 필수 참조 매뉴얼 여부 (병원당 1개) */
        isAiMandatoryReference?: boolean;
      }[];
    }[];
    /** 폴더에 속하지 않은 치료 태그 목록 */
    unassignedTags: {
      /** 치료 태그 ID */
      _id?: string;
      /** 치료 태그 이름 */
      categoryName?: string;
      /** 치료 태그 정렬 순서 - 클수록 먼저 표시됨 */
      sortNum?: number;
      /** 치료 태그 활성화 여부 */
      isActive?: boolean;
      /** 치료 태그 색상 팔레트 인덱스 */
      paletteIndex?: number;
      /** 사용자 정의 색상 사용 여부 */
      isUsingCustomColor?: boolean;
      /** 치료 태그 색상 */
      color?: string;
      /** AI 상담코치 필수 참조 매뉴얼 여부 (병원당 1개) */
      isAiMandatoryReference?: boolean;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TreatmentCategoryControllerSetAiMandatoryReferenceBodyRequest {
  /** (required) 치료 태그 ID */
  treatmentTagID: string;
  /** (required) AI 필수 참조 설정 여부 */
  isAiMandatoryReference: boolean;
}

export interface TreatmentCategoryControllerSetAiMandatoryReferenceResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 치료 태그 ID */
    _id?: string;
    /** 병원 ID */
    hospitalID?: string;
    /** 치료 태그 이름 */
    categoryName?: string;
    /** AI 필수 참조 설정 여부 */
    isAiMandatoryReference?: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ManualAllContentsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 특정 병원의 활성화된 치료태그 매뉴얼 데이터 목록 */
  data: {
    /**
     * 치료태그 ID
     * @example "66ac5bae07a37e99d4ae628b"
     */
    treatmentTagId: string;
    /**
     * 치료태그 이름
     * @example "척추교정"
     */
    treatmentTagName: string;
    /**
     * 폴더 ID
     * @example "66ac4be507a37e99d4ae6272"
     */
    folderId?: string;
    /**
     * 폴더 이름
     * @example "체형 교정 시술"
     */
    folderName?: string;
    /**
     * 매뉴얼 내용
     * @example "도수치료는 우리 몸의 세포와 기관에 적절한 자극과 연료가 공급될 수 있도록 여러 가지 조작을 해주며, 뇌로 전달되는 감각 수용체의 활동을 증가시켜 뇌에 대한 자극을 극대화 시키기 때문에 궁극적으로 우리 삶을 건강하고 활동적으로 만들어 줍니다."
     */
    manualContent: string;
    /** 주의사항 이미지 URL 목록 */
    treatmentCautionImages: string[];
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UpdatingFolderSortHandlerBodyRequest {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 폴더 ID
   * @example "66ac5bae07a37e99d4ae628d"
   */
  folderID: string;
  /**
   * 변경할 정렬 값
   * @example 9
   */
  targetSortNum?: number;
  /**
   * 해당 폴더를 이 정렬값으로 바꿀건데 이 정렬값을 가지고 이보다 큰 폴더들은 각 정렬 값이 +1씩 됨
   * @example 8
   */
  beforeSortNum?: number;
  /**
   * 해당 폴더를 이 정렬값으로 바꿀건데 이 정렬값을 가지고 이보다 작은 폴더들은 각 정렬 값이 -1씩 됨
   * @example 4
   */
  afterSortNum?: number;
}

export interface UpdatingFolderSortHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 폴더 정렬값 수정 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
    /** 정렬 값 적용 후 폴더 전체 목록 */
    folders: {
      /**
       * 폴더 ID
       * @example "66ac5bae07a37e99d4ae628d"
       */
      folderID: string;
      /**
       * 병원 ID
       * @example "63d7bafc1374672f7c407efd"
       */
      hospitalID: string;
      /**
       * 폴더 이름
       * @example "체형 교정 시술"
       */
      folderName: string;
      /**
       * 정렬 값
       * @example 9
       */
      sortNum: number;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type ApiManualsElFoldersCreateData = ApiResponse & {
  data?: any;
};

export interface ApiManualsElFoldersParams {
  /** 병원 ID */
  hospitalID: string;
  /** 검색하고자 하는 폴더 또는 태그 이름 - Like 검색 */
  folderOrTagName?: string;
  /** true일 경우 활성화된 폴더만 조회 */
  onlyActive?: boolean;
}

export type ApiManualsElFoldersData = ApiResponse & {
  data: ManualFolderList;
};

export type ApiManualsElFoldersUpdateData = ApiResponse & {
  data: {
    /**
     * 폴더 정보 수정 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
  };
};

export type ApiManualsElFoldersDeleteData = ApiResponse & {
  data: {
    /** 폴더 삭제 성공 여부 */
    isDeletedSuccess: boolean;
  };
};

export type ApiManualsElUpsertSingleData = ApiResponse & {
  data: {
    /** 매뉴얼 생성 성공 여부 */
    isCreatedSuccess: boolean;
  };
};

export type ApiManualsElTreatmentCautionsChatData = ApiResponse & {
  data: {
    /**
     * 치료 주의사항 채팅 전송 성공 여부
     * @example true
     */
    isSentSuccess: boolean;
    /**
     * 전송된 채팅 ID
     * @example "66ceb65989b82a24ee87a3c6"
     */
    chatID: string;
  };
};

export type ApiManualsElDeleteData = ApiResponse & {
  data: {
    /**
     * 삭제 성공 여부
     * @example true
     */
    isDeletedSuccess: boolean;
  };
};

export interface ApiManualsElSingleParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 치료 태그 ID
   * @example "66ac5bae07a37e99d4ae628d"
   */
  treatmentTagId?: string;
}

export type ApiManualsElSingleData = ApiResponse & {
  data: ManualResponse;
};

export interface TreatmentCategoryControllerGetManualFolderParams {
  /** 병원 ID */
  hospitalID: string;
  /** 검색하고자 하는 폴더 또는 태그 이름 - 부분 일치, 대소문자 무시 */
  folderOrTagName?: string;
  /**
   * 활성화된 폴더·태그만 조회 (boolean string: true/false)
   * @example "true"
   */
  onlyActive?: string;
}

export type TreatmentCategoryControllerGetManualFolderData = TreatmentCategoryControllerGetManualFolderListResponse;

export type TreatmentCategoryControllerSetAiMandatoryReferenceData =
  TreatmentCategoryControllerSetAiMandatoryReferenceResponse;

export interface ManualAllContentsHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type ManualAllContentsHandlerData = ManualAllContentsHandlerResponse;

export type UpdatingFolderSortHandlerData = UpdatingFolderSortHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 새로운 폴더를 생성합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElFoldersCreate
     * @summary 새 폴더 생성
     * @request POST:/v3/api/manuals/el/folders/create
     * @secure
     * @response `201` `ApiManualsElFoldersCreateData` 폴더가 성공적으로 생성됨
     */
    apiManualsElFoldersCreate: (
      data: {
        /**
         * 폴더 이름
         * @example "피부 관리"
         */
        name?: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElFoldersCreateData, any>({
        path: `/v3/api/manuals/el/folders/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원의 모든 폴더 목록을 조회합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElFolders
     * @summary 폴더 목록 조회
     * @request GET:/v3/api/manuals/el/folders
     * @secure
     * @response `200` `ApiManualsElFoldersData` 성공적으로 폴더 목록을 조회함
     */
    apiManualsElFolders: (query: ApiManualsElFoldersParams, params: RequestParams = {}) =>
      this.request<ApiManualsElFoldersData, any>({
        path: `/v3/api/manuals/el/folders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 폴더의 이름을 수정하거나 활성화 여부를 변경할 수 있습니다. 폴더의 정렬 순서를 변경할 경우, 해당 폴더의 정렬 순서를 변경하고, 다른 폴더들의 정렬 순서를 조정합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElFoldersUpdate
     * @summary 폴더 정보 수정
     * @request POST:/v3/api/manuals/el/folders/update
     * @secure
     * @response `200` `ApiManualsElFoldersUpdateData` 폴더 정보가 성공적으로 수정됨
     */
    apiManualsElFoldersUpdate: (
      data: {
        /**
         * 수정할 폴더의 ID
         * @example "66ac4be507a37e99d4ae6273"
         */
        folderId: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
        /**
         * 수정할 폴더 이름
         * @example "초진 환자 중점 관리"
         */
        name?: string;
        /**
         * 수정할 활성화 여부
         * @default true
         * @example true
         */
        isActive?: boolean;
        /**
         * 수정할 정렬 순서
         * @example 15
         */
        sortNum?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElFoldersUpdateData, any>({
        path: `/v3/api/manuals/el/folders/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 지정된 폴더를 삭제합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElFoldersDelete
     * @summary 폴더 삭제
     * @request POST:/v3/api/manuals/el/folders/delete
     * @secure
     * @response `200` `ApiManualsElFoldersDeleteData` 폴더가 성공적으로 삭제됨
     */
    apiManualsElFoldersDelete: (
      data: {
        /**
         * 삭제할 폴더의 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        folderId: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElFoldersDeleteData, any>({
        path: `/v3/api/manuals/el/folders/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료태그 매뉴얼을 생성 또는 수정합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElUpsertSingle
     * @summary 매뉴얼 생성 또는 수정
     * @request POST:/v3/api/manuals/el/upsert/single
     * @secure
     * @response `201` `ApiManualsElUpsertSingleData` 치료 태그 매뉴얼이 성공적으로 생성됨
     */
    apiManualsElUpsertSingle: (
      data: {
        /**
         * 연관된 치료 태그의 ID
         * @example "66ac5bae07a37e99d4ae628d"
         */
        treatmentTagID: string;
        /**
         * 매뉴얼 본문 내용
         * @example "치료 태그 매뉴얼 내용입니다."
         */
        manualContent?: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
        /**
         * 매뉴얼 관련 이미지 파일 ID (File 컬렉션 아이디) - File API 를 사용하여 이미지 업로드 후에 넣어주셔야 합니다.
         * @example "650cf3be0cc5ce37e9d108c0"
         */
        fileID?: string;
        /**
         * 주의사항 메세지 텍스트
         * @example "주의사항 - "
         */
        cautionMessage?: string;
        /**
         * 주의사항 메세지 발송 여부
         * @example false
         */
        usingCautionMessage?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElUpsertSingleData, any>({
        path: `/v3/api/manuals/el/upsert/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원의 치료 주의사항 이미지를 채팅방에 전송합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElTreatmentCautionsChat
     * @summary 매뉴얼 치료 주의사항 채팅 전송
     * @request POST:/v3/api/manuals/el/treatment-cautions/chat
     * @secure
     * @response `200` `ApiManualsElTreatmentCautionsChatData` 매뉴얼 치료 주의사항 채팅 전송 여부
     */
    apiManualsElTreatmentCautionsChat: (
      data: {
        /**
         * 전송할 채팅방 ID
         * @example "66ceb65989b82a24ee87a3c6"
         */
        targetChatRoomID: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
        /**
         * 전송할 치료 태그 주의사항 이미지가 소속된 치료 태그 ID
         * @example "66ceb65989b82a24ee87a3c6"
         */
        treatmentTagID: string;
        /**
         * 전송할 치료 태그 주의사항 이미지 중 선택된 이미지 인덱스
         * @example [0,1]
         */
        selectedImageIndices: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElTreatmentCautionsChatData, any>({
        path: `/v3/api/manuals/el/treatment-cautions/chat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 치료태그에 대한 매뉴얼을 삭제합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElDelete
     * @summary 치료태그 매뉴얼 삭제
     * @request POST:/v3/api/manuals/el/delete
     * @secure
     * @response `200` `ApiManualsElDeleteData` 해당 치료태그에 대한 매뉴얼이 성공적으로 삭제됨
     * @response `400` `ApiResponse` Bad Request
     * @response `404` `ApiResponse` Not Found
     */
    apiManualsElDelete: (
      data: {
        /**
         * 연관된 치료 태그의 ID
         * @example "66ac5bae07a37e99d4ae628d"
         */
        treatmentTagID: string;
        /**
         * 병원 ID
         * @example "63d7bafc1374672f7c407efd"
         */
        hospitalID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiManualsElDeleteData, ApiResponse>({
        path: `/v3/api/manuals/el/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 치료태그의 매뉴얼을 조회합니다.
     *
     * @tags V3-Manual
     * @name ApiManualsElSingle
     * @summary 특정 치료태그에 대한 매뉴얼 조회
     * @request GET:/v3/api/manuals/el/single
     * @secure
     * @response `200` `ApiManualsElSingleData` 성공적으로 특정 치료태그 매뉴얼 정보를 조회함
     */
    apiManualsElSingle: (query: ApiManualsElSingleParams, params: RequestParams = {}) =>
      this.request<ApiManualsElSingleData, any>({
        path: `/v3/api/manuals/el/single`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Manual
     * @name TreatmentCategoryControllerGetManualFolder
     * @summary 폴더 목록 조회 — 병원의 폴더와 하위 치료 태그, 폴더 없는 치료 태그를 반환
     * @request GET:/v3/api/manuals/folders
     * @secure
     * @response `200` `TreatmentCategoryControllerGetManualFolderData` success
     */
    treatmentCategoryControllerGetManualFolder: (
      query: TreatmentCategoryControllerGetManualFolderParams,
      params: RequestParams = {},
    ) =>
      this.request<TreatmentCategoryControllerGetManualFolderData, any>({
        path: `/v3/api/manuals/folders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-Manual
     * @name TreatmentCategoryControllerSetAiMandatoryReference
     * @summary 원내매뉴얼 AI 필수 참조 설정/해제 (즉시 반영, 병원당 1개)
     * @request PATCH:/v3/api/manuals/el/ai-mandatory-reference
     * @secure
     * @response `200` `TreatmentCategoryControllerSetAiMandatoryReferenceData` success
     */
    treatmentCategoryControllerSetAiMandatoryReference: (
      data: TreatmentCategoryControllerSetAiMandatoryReferenceBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TreatmentCategoryControllerSetAiMandatoryReferenceData, any>({
        path: `/v3/api/manuals/el/ai-mandatory-reference`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 활성화된 치료태그 매뉴얼 데이터 전부를 조회합니다.
     *
     * @tags V3-Manual
     * @name ManualAllContentsHandler
     * @summary 특정 병원 활성화 치료태그 매뉴얼 데이터 전부 조회
     * @request GET:/v3/api/manuals/el/find/all
     * @secure
     * @response `200` `ManualAllContentsHandlerData` success
     */
    manualAllContentsHandler: (query: ManualAllContentsHandlerParams, params: RequestParams = {}) =>
      this.request<ManualAllContentsHandlerData, any>({
        path: `/v3/api/manuals/el/find/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 폴더의 정렬값을 수정합니다.
     *
     * @tags V3-Manual
     * @name UpdatingFolderSortHandler
     * @summary 특정 폴더 정렬값 수정
     * @request PATCH:/v3/api/manuals/el/folders/sort
     * @secure
     * @response `200` `UpdatingFolderSortHandlerData` success
     */
    updatingFolderSortHandler: (data: UpdatingFolderSortHandlerBodyRequest, params: RequestParams = {}) =>
      this.request<UpdatingFolderSortHandlerData, any>({
        path: `/v3/api/manuals/el/folders/sort`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
